export type Language = 'fr' | 'en' | 'es' | 'de';

export const LANGUAGE_NAMES: Record<Language, { name: string; flag: string }> = {
  fr: { name: 'Français', flag: '🇫🇷' },
  en: { name: 'English', flag: '🇬🇧' },
  es: { name: 'Español', flag: '🇪🇸' },
  de: { name: 'Deutsch', flag: '🇩🇪' },
};

export const TRANSLATIONS = {
  fr: {
    // Header
    appTitle: "COUPE ICARE",
    subTitleTag: "STAND OCCAZ",
    headerSubtitle: "Consultation en direct • {count} / {total} lots",
    ptvCalculatorBtn: "Calculateur PTV",
    favoritesBtn: "Favoris",
    refreshing: "Chargement...",
    // FilterBar
    searchPlaceholder: "Rechercher (n° lot, coupon, marque, modèle, homologation...)",
    filtersBtn: "Filtres",
    allCategories: "Tous",
    lotsCategory: "Lots",
    gliders: "Voiles",
    harnesses: "Sellettes",
    reserves: "Secours",
    accessories: "Accessoires",
    typeGlider: "Voile",
    typeHarness: "Sellette",
    typeReserve: "Secours",
    typeAccessory: "Accessoire",
    statusEnVente: "En vente",
    statusPaye: "Payé",
    statusRestitue: "Restitué",
    statusAll: "Tous statuts",
    allLevels: "Tous niveaux",
    levelSchool: "🟢 Débutant (EN-A)",
    levelProgression: "🔵 Cross (EN-B)",
    levelPerformance: "🔴 Performance (EN-C+)",
    levelLight: "🪶 Rando / Light",
    levelTandem: "👥 Biplace / Tandem",
    sortBy: "Trier par :",
    sortLot: "Numéro de Lot",
    sortPrice: "Prix de vente",
    sortBrand: "Marque",
    sortPtv: "PTV Max",
    sortSize: "Taille",
    sortHomologation: "Homologation",
    sortYear: "Année",
    groupNoYear: "Année inconnue",
    groupNoSize: "Taille inconnue",
    groupNoHomologation: "Sans homologation",
    pilotPtvLabel: "🪂 Votre PTV (kg)",
    brandLabel: "🏷️ Marque",
    allBrands: "Toutes les marques",
    homologationLabel: "Homologation",
    allHomologations: "Toutes homologations",
    priceLabel: "💶 Prix (€)",
    resetFilters: "Réinitialiser tous les filtres",
    // Cards & Table
    lotNum: "LOT",
    couponNum: "Coupon",
    sizeLabel: "Taille",
    yearLabel: "Année",
    colorLabel: "Couleur",
    ptvRange: "PTV: {min} - {max} kg",
    viewDetails: "Voir détails →",
    actions: "FAV",
    // PTV Positions & Gauge
    ptvLowZone: "Bas de fourchette (Vol doux, amorti)",
    ptvMidZone: "Milieu de fourchette (Comportement optimal)",
    ptvHighZone: "Haut de fourchette (Vitesse & manœuvrabilité)",
    ptvPosition: "Position du pilote : {pct}% • {zone}",
    // Details Modal
    techSpecs: "Caractéristiques Techniques",
    comments: "Commentaires / État du matériel",
    copySummary: "Copier résumé",
    copied: "Copié !",
    printCoupon: "Imprimer coupon",
    searchEcosia: "Rechercher essais & avis sur Ecosia 🌱",
    searchKeywords: "parapente essai test avis",
    // Compare
    compareBarTitle: "{count} lot(s) sélectionné(s) pour comparaison",
    compareBtn: "Comparer les lots",
    clearCompare: "Vider",
    compareModalTitle: "Comparatif des Lots ({count})",
    closeCompare: "Fermer le comparatif",
    fullSheet: "Voir fiche complète →",
    // PTV Calc Modal
    ptvCalcTitle: "Calculateur de PTV Pilote",
    ptvCalcIntro: "Le PTV (Poids Total Volant) additionne votre poids et tout votre matériel. L'appli ne garde que les voiles dont la fourchette de vol vous inclut et vous situe dedans (bas, milieu ou haut de fourchette) — ce qui donne une idée du comportement de la voile.",
    pilotWeightLabel: "🧍 Votre poids (kg)",
    gliderWeightLabel: "🪂 Poids voile (kg)",
    harnessWeightLabel: "💺 Poids sellette (kg)",
    reserveWeightLabel: "🆘 Poids secours (kg)",
    extraWeightLabel: "🎒 Équipement divers (kg)",
    ptvTotalLabel: "PTV total",
    ptvClear: "Effacer",
    ptvApply: "Appliquer le PTV",
    // Settings Modal
    settingsTitle: "Paramètres du Stand Occasion",
    dataSourceTitle: "Source de données (Mode Test / Dev)",
    dataSourceHelp: "Adresse URL HTTP/HTTPS ou S3 de test pour le fichier JSON (ex: standoccaz-test.json).",
    resetTestUrl: "Restaurer l'URL S3 de test",
    autoRefreshTitle: "Rafraîchissement automatique",
    autoRefreshHelp: "Fréquence à laquelle l'application interroge le bucket S3 pour mettre à jour la liste des lots.",
    disabled: "Désactivé",
    every60s: "Chaque minute",
    save: "Enregistrer",
    cancel: "Annuler",
    // Stats Bar
    totalLotsCount: "Lots",
    totalLots: "Articles totaux",
    inSale: "En vente",
    glidersCount: "Voiles 🪂",
    harnessesCount: "Sellettes 💺",
    reservesCount: "Secours 🆘",
    accessoriesCount: "Accessoires 🛠",
    avgPrice: "Prix moyen",
    priceRange: "Fourchette prix",
    // Empty & Errors
    emptyTitle: "Aucun lot ne correspond à vos critères",
    emptySub: "Essayez de modifier votre recherche ou de réinitialiser vos filtres.",
    offlineModeBanner: "Données de démonstration — le fichier de production n'est pas encore disponible.",
    // Filter group labels, placeholders & fallbacks
    filterGroupType: "Type",
    filterGroupLevel: "Niveau",
    ptvPlaceholder: "Ex : 85",
    priceMinPlaceholder: "Min €",
    priceMaxPlaceholder: "Max €",
    retry: "Réessayer",
    errorTimeout: "Délai réseau dépassé (5 s).",
    errorNetwork: "Erreur réseau.",
    // Alerts (new matching lots)
    alertOn: "M'alerter",
    alertOff: "Alerte active",
    alertTooltipOn: "M'alerter des nouveaux lots correspondant à ces filtres",
    alertTooltipOff: "Alerte active sur ces filtres — cliquer pour désactiver",
    alertNewMatchTitle: "{count} nouveau(x) lot(s) pour votre alerte",
    alertViewBtn: "Consulter",
    viewingNewLots: "{count} nouveau(x) lot(s) de votre alerte",
    showAllLots: "Tout afficher",
    alertAndMore: "+ {count} autre(s)",
    alertAllArticles: "tous les articles",
    alertClose: "Fermer",
    alertSetupTitle: "Activer l'alerte",
    alertSetupIntro: "Une popup s'affichera dans l'app dès qu'un nouveau lot en vente correspond à votre sélection.",
    alertSetupWatching: "Critère surveillé :",
    alertSetupTabOpen: "L'alerte fonctionne tant que cet onglet reste ouvert.",
    alertSetupBrowserNotif: "Me prévenir aussi quand cet onglet est en arrière-plan (notification système)",
    alertSetupConfirm: "Activer l'alerte",
    compareMax: "4 lots maximum pour la comparaison.",
    noBrand: "SANS MARQUE",
    noModel: "Modèle non spécifié",
    articlesCount: "{count} articles",
    ptvLabel: "PTV",
  },

  en: {
    // Header
    appTitle: "COUPE ICARE",
    subTitleTag: "GEAR SHOP",
    headerSubtitle: "Live Consultation • {count} / {total} items",
    ptvCalculatorBtn: "Weight Calculator",
    favoritesBtn: "Favorites",
    refreshing: "Loading...",
    // FilterBar
    searchPlaceholder: "Search (lot #, coupon, brand, model, cert...)",
    filtersBtn: "Filters",
    allCategories: "All",
    lotsCategory: "Bundles",
    gliders: "Gliders",
    harnesses: "Harnesses",
    reserves: "Reserves",
    accessories: "Accessories",
    typeGlider: "Glider",
    typeHarness: "Harness",
    typeReserve: "Reserve",
    typeAccessory: "Accessory",
    statusEnVente: "For Sale",
    statusPaye: "Paid",
    statusRestitue: "Returned",
    statusAll: "All Statuses",
    allLevels: "All Levels",
    levelSchool: "🟢 Beginner (EN-A)",
    levelProgression: "🔵 Progression (EN-B)",
    levelPerformance: "🔴 Performance (EN-C+)",
    levelLight: "🪶 Hike & Fly / Light",
    levelTandem: "👥 Tandem",
    sortBy: "Sort by:",
    sortLot: "Lot Number",
    sortPrice: "Sale Price",
    sortBrand: "Brand",
    sortPtv: "Max Weight",
    sortSize: "Size",
    sortHomologation: "Certification",
    sortYear: "Year",
    groupNoYear: "Unknown year",
    groupNoSize: "Unknown size",
    groupNoHomologation: "Uncertified",
    pilotPtvLabel: "🪂 Your weight (kg)",
    brandLabel: "🏷️ Brand",
    allBrands: "All Brands",
    homologationLabel: "Certification",
    allHomologations: "All Certifications",
    priceLabel: "💶 Price (€)",
    resetFilters: "Reset All Filters",
    // Cards & Table
    lotNum: "LOT",
    couponNum: "Coupon",
    sizeLabel: "Size",
    yearLabel: "Year",
    colorLabel: "Color",
    ptvRange: "Weight: {min} - {max} kg",
    viewDetails: "View Details →",
    actions: "FAV",
    // PTV Positions & Gauge
    ptvLowZone: "Low Weight Range (Calm & Smooth)",
    ptvMidZone: "Mid Weight Range (Optimal All-Round)",
    ptvHighZone: "High Weight Range (Speed & Handling)",
    ptvPosition: "Pilot Loading: {pct}% • {zone}",
    // Details Modal
    techSpecs: "Technical Specifications",
    comments: "Comments / Gear Condition",
    copySummary: "Copy Summary",
    copied: "Copied!",
    printCoupon: "Print Tag",
    searchEcosia: "Search Reviews & Tests on Ecosia 🌱",
    searchKeywords: "paraglider review test",
    // Compare
    compareBarTitle: "{count} item(s) selected for comparison",
    compareBtn: "Compare Selected",
    clearCompare: "Clear",
    compareModalTitle: "Item Comparison ({count})",
    closeCompare: "Close Comparison",
    fullSheet: "View Full Sheet →",
    // PTV Calc Modal
    ptvCalcTitle: "Total Flight Weight Calculator",
    ptvCalcIntro: "All-Up Weight (AUW) adds your body weight to all your gear. The app keeps only gliders whose certified weight range includes you and shows where you sit within it (low, middle or high) — a hint of how the glider will behave.",
    pilotWeightLabel: "🧍 Your weight (kg)",
    gliderWeightLabel: "🪂 Glider weight (kg)",
    harnessWeightLabel: "💺 Harness weight (kg)",
    reserveWeightLabel: "🆘 Reserve weight (kg)",
    extraWeightLabel: "🎒 Extra gear (kg)",
    ptvTotalLabel: "Total flight weight",
    ptvClear: "Clear",
    ptvApply: "Apply weight",
    // Settings Modal
    settingsTitle: "Gear Shop Settings",
    dataSourceTitle: "Data Source (Test / Dev Mode)",
    dataSourceHelp: "HTTP/HTTPS or S3 URL endpoint for the JSON data file.",
    resetTestUrl: "Reset Test S3 URL",
    autoRefreshTitle: "Auto Refresh",
    autoRefreshHelp: "How often the app polls the S3 bucket to refresh available gear.",
    disabled: "Disabled",
    every60s: "Every minute",
    save: "Save",
    cancel: "Cancel",
    // Stats Bar
    totalLotsCount: "Lots",
    totalLots: "Total Items",
    inSale: "For Sale",
    glidersCount: "Gliders 🪂",
    harnessesCount: "Harnesses 💺",
    reservesCount: "Reserves 🆘",
    accessoriesCount: "Accessories 🛠",
    avgPrice: "Avg Price",
    priceRange: "Price Range",
    // Empty & Errors
    emptyTitle: "No items match your criteria",
    emptySub: "Try modifying your search or resetting your filters.",
    offlineModeBanner: "Demo data — production file is not yet available.",
    // Filter group labels, placeholders & fallbacks
    filterGroupType: "Type",
    filterGroupLevel: "Level",
    ptvPlaceholder: "e.g. 85",
    priceMinPlaceholder: "Min €",
    priceMaxPlaceholder: "Max €",
    retry: "Retry",
    errorTimeout: "Network timeout (5s).",
    errorNetwork: "Network error.",
    // Alerts (new matching lots)
    alertOn: "Alert me",
    alertOff: "Alert active",
    alertTooltipOn: "Alert me about new lots matching these filters",
    alertTooltipOff: "Alert active on these filters — click to turn off",
    alertNewMatchTitle: "{count} new lot(s) for your alert",
    alertViewBtn: "View",
    viewingNewLots: "{count} new lot(s) from your alert",
    showAllLots: "Show all",
    alertAndMore: "+ {count} more",
    alertAllArticles: "all items",
    alertClose: "Close",
    alertSetupTitle: "Enable alert",
    alertSetupIntro: "A popup will appear in the app as soon as a new lot for sale matches your selection.",
    alertSetupWatching: "Watched criteria:",
    alertSetupTabOpen: "The alert works while this tab stays open.",
    alertSetupBrowserNotif: "Also notify me when this tab is in the background (system notification)",
    alertSetupConfirm: "Enable alert",
    compareMax: "Up to 4 lots for comparison.",
    noBrand: "NO BRAND",
    noModel: "Model not specified",
    articlesCount: "{count} items",
    ptvLabel: "Weight",
  },

  es: {
    // Header
    appTitle: "COUPE ICARE",
    subTitleTag: "MERCADILLO",
    headerSubtitle: "En Vivo • {count} / {total} lotes",
    ptvCalculatorBtn: "Calculadora PTV",
    favoritesBtn: "Favoritos",
    refreshing: "Cargando...",
    // FilterBar
    searchPlaceholder: "Buscar (n° lote, cupón, marca, modelo, homologación...)",
    filtersBtn: "Filtros",
    allCategories: "Todos",
    lotsCategory: "Lotes",
    gliders: "Velas",
    harnesses: "Arneses",
    reserves: "Paracaídas",
    accessories: "Accesorios",
    typeGlider: "Vela",
    typeHarness: "Arnés",
    typeReserve: "Paracaídas",
    typeAccessory: "Accesorio",
    statusEnVente: "En venta",
    statusPaye: "Pagado",
    statusRestitue: "Devuelto",
    statusAll: "Todos",
    allLevels: "Todos niveles",
    levelSchool: "🟢 Principiante (EN-A)",
    levelProgression: "🔵 Progresión (EN-B)",
    levelPerformance: "🔴 Rendimiento (EN-C+)",
    levelLight: "🪶 Vuelo Rando / Ligero",
    levelTandem: "👥 Biplaza / Tándem",
    sortBy: "Ordenar por:",
    sortLot: "Número de Lote",
    sortPrice: "Precio de Venta",
    sortBrand: "Marca",
    sortPtv: "PTV Máx",
    sortSize: "Talla",
    sortHomologation: "Homologación",
    sortYear: "Año",
    groupNoYear: "Año desconocido",
    groupNoSize: "Talla desconocida",
    groupNoHomologation: "Sin homologación",
    pilotPtvLabel: "🪂 Su PTV (kg)",
    brandLabel: "🏷️ Marca",
    allBrands: "Todas las marcas",
    homologationLabel: "Homologación",
    allHomologations: "Todas las homologaciones",
    priceLabel: "💶 Precio (€)",
    resetFilters: "Restablecer filtros",
    // Cards & Table
    lotNum: "LOTE",
    couponNum: "Cupón",
    sizeLabel: "Talla",
    yearLabel: "Año",
    colorLabel: "Color",
    ptvRange: "PTV: {min} - {max} kg",
    viewDetails: "Ver detalles →",
    actions: "FAV",
    // PTV Positions & Gauge
    ptvLowZone: "Bajo de Rango (Vuelo suave)",
    ptvMidZone: "Medio de Rango (Óptimo y polivalente)",
    ptvHighZone: "Alto de Rango (Velocidad & agilidad)",
    ptvPosition: "Carga piloto: {pct}% • {zone}",
    // Details Modal
    techSpecs: "Especificaciones Técnicas",
    comments: "Comentarios / Estado del equipo",
    copySummary: "Copiar resumen",
    copied: "¡Copiado!",
    printCoupon: "Imprimir etiqueta",
    searchEcosia: "Buscar pruebas & opiniones en Ecosia 🌱",
    searchKeywords: "parapente prueba opinion",
    // Compare
    compareBarTitle: "{count} lote(s) seleccionado(s) para comparar",
    compareBtn: "Comparar lotes",
    clearCompare: "Vaciar",
    compareModalTitle: "Comparativa de Lotes ({count})",
    closeCompare: "Cerrar comparativa",
    fullSheet: "Ver ficha completa →",
    // PTV Calc Modal
    ptvCalcTitle: "Calculadora de PTV Piloto",
    ptvCalcIntro: "El PTV (Peso Total en Vuelo) suma tu peso y todo tu equipo. La app solo muestra las velas cuyo rango de peso homologado te incluye y te sitúa dentro de él (bajo, medio o alto) — una idea del comportamiento de la vela.",
    pilotWeightLabel: "🧍 Tu peso (kg)",
    gliderWeightLabel: "🪂 Peso vela (kg)",
    harnessWeightLabel: "💺 Peso arnés (kg)",
    reserveWeightLabel: "🆘 Peso reserva (kg)",
    extraWeightLabel: "🎒 Equipo extra (kg)",
    ptvTotalLabel: "PTV total",
    ptvClear: "Borrar",
    ptvApply: "Aplicar PTV",
    // Settings Modal
    settingsTitle: "Ajustes de la Tienda",
    dataSourceTitle: "Fuente de datos (Modo Test)",
    dataSourceHelp: "URL HTTP/HTTPS o S3 para el archivo de datos JSON.",
    resetTestUrl: "Restablecer URL de prueba",
    autoRefreshTitle: "Actualización automática",
    autoRefreshHelp: "Frecuencia con la que la app consulta S3 para actualizar los lotes.",
    disabled: "Desactivado",
    every60s: "Cada minuto",
    save: "Guardar",
    cancel: "Cancelar",
    // Stats Bar
    totalLotsCount: "Lotes",
    totalLots: "Artículos totales",
    inSale: "En venta",
    glidersCount: "Velas 🪂",
    harnessesCount: "Arneses 💺",
    reservesCount: "Emergencias 🆘",
    accessoriesCount: "Accesorios 🛠",
    avgPrice: "Precio medio",
    priceRange: "Rango de precios",
    // Empty & Errors
    emptyTitle: "Ningún lote coincide con tus criterios",
    emptySub: "Intenta modificar tu búsqueda o restablecer los filtros.",
    offlineModeBanner: "Datos de demostración — el archivo de producción aún no está disponible.",
    // Filter group labels, placeholders & fallbacks
    filterGroupType: "Tipo",
    filterGroupLevel: "Nivel",
    ptvPlaceholder: "Ej: 85",
    priceMinPlaceholder: "Mín €",
    priceMaxPlaceholder: "Máx €",
    retry: "Reintentar",
    errorTimeout: "Tiempo de red agotado (5 s).",
    errorNetwork: "Error de red.",
    // Alerts (new matching lots)
    alertOn: "Avisarme",
    alertOff: "Alerta activa",
    alertTooltipOn: "Avisarme de nuevos lotes que coincidan con estos filtros",
    alertTooltipOff: "Alerta activa en estos filtros — pulsa para desactivar",
    alertNewMatchTitle: "{count} nuevo(s) lote(s) para tu alerta",
    alertViewBtn: "Ver",
    viewingNewLots: "{count} nuevo(s) lote(s) de tu alerta",
    showAllLots: "Mostrar todo",
    alertAndMore: "+ {count} más",
    alertAllArticles: "todos los artículos",
    alertClose: "Cerrar",
    alertSetupTitle: "Activar alerta",
    alertSetupIntro: "Aparecerá una ventana emergente en la app en cuanto un nuevo lote en venta coincida con tu selección.",
    alertSetupWatching: "Criterio vigilado:",
    alertSetupTabOpen: "La alerta funciona mientras esta pestaña permanezca abierta.",
    alertSetupBrowserNotif: "Avisarme también cuando esta pestaña esté en segundo plano (notificación del sistema)",
    alertSetupConfirm: "Activar alerta",
    compareMax: "Máximo 4 lotes para comparar.",
    noBrand: "SIN MARCA",
    noModel: "Modelo no especificado",
    articlesCount: "{count} artículos",
    ptvLabel: "PTV",
  },

  de: {
    // Header
    appTitle: "COUPE ICARE",
    subTitleTag: "GEBRAUCHTMARKT",
    headerSubtitle: "Live-Abfrage • {count} / {total} Artikel",
    ptvCalculatorBtn: "Gewichtsrechner",
    favoritesBtn: "Favoriten",
    refreshing: "Laden...",
    // FilterBar
    searchPlaceholder: "Suchen (Lot-Nr., Coupon, Marke, Modell, Gütesiegel...)",
    filtersBtn: "Filter",
    allCategories: "Alle",
    lotsCategory: "Sets",
    gliders: "Schirme",
    harnesses: "Gurtzeuge",
    reserves: "Rettungen",
    accessories: "Zubehör",
    typeGlider: "Schirm",
    typeHarness: "Gurtzeug",
    typeReserve: "Rettung",
    typeAccessory: "Zubehör",
    statusEnVente: "Zum Verkauf",
    statusPaye: "Bezahlt",
    statusRestitue: "Zurückgegeben",
    statusAll: "Alle Status",
    allLevels: "Alle Stufen",
    levelSchool: "🟢 Einsteiger (EN-A)",
    levelProgression: "🔵 Aufsteiger / Cross (EN-B)",
    levelPerformance: "🔴 Leistung (EN-C+)",
    levelLight: "🪶 Hike & Fly / Leicht",
    levelTandem: "👥 Tandem",
    sortBy: "Sortieren nach:",
    sortLot: "Lot-Nummer",
    sortPrice: "Verkaufspreis",
    sortBrand: "Marke",
    sortPtv: "Max. Startgewicht",
    sortSize: "Größe",
    sortHomologation: "Gütesiegel",
    sortYear: "Jahr",
    groupNoYear: "Jahr unbekannt",
    groupNoSize: "Größe unbekannt",
    groupNoHomologation: "Ohne Gütesiegel",
    pilotPtvLabel: "🪂 Ihr Startgewicht (kg)",
    brandLabel: "🏷️ Marke",
    allBrands: "Alle Marken",
    homologationLabel: "Gütesiegel",
    allHomologations: "Alle Gütesiegel",
    priceLabel: "💶 Preis (€)",
    resetFilters: "Alle Filter zurücksetzen",
    // Cards & Table
    lotNum: "LOT",
    couponNum: "Coupon",
    sizeLabel: "Größe",
    yearLabel: "Jahr",
    colorLabel: "Farbe",
    ptvRange: "Startgewicht: {min} - {max} kg",
    viewDetails: "Details ansehen →",
    actions: "FAV",
    // PTV Positions & Gauge
    ptvLowZone: "Untere Gewichtsgrenze (Ruhig & gedämpft)",
    ptvMidZone: "Mittlere Gewichtsgrenze (Optimal & allround)",
    ptvHighZone: "Obere Gewichtsgrenze (Geschwindigkeit & Dynamik)",
    ptvPosition: "Belastung: {pct}% • {zone}",
    // Details Modal
    techSpecs: "Technische Daten",
    comments: "Kommentare / Zustand",
    copySummary: "Zusammenfassung kopieren",
    copied: "Kopiert!",
    printCoupon: "Coupon drucken",
    searchEcosia: "Tests & Testberichte auf Ecosia suchen 🌱",
    searchKeywords: "gleitschirm testbericht test",
    // Compare
    compareBarTitle: "{count} Artikel zum Vergleich ausgewählt",
    compareBtn: "Artikel vergleichen",
    clearCompare: "Leeren",
    compareModalTitle: "Artikelvergleich ({count})",
    closeCompare: "Vergleich schließen",
    fullSheet: "Vollständiges Datenblatt →",
    // PTV Calc Modal
    ptvCalcTitle: "Startgewichts-Rechner",
    ptvCalcIntro: "Das Startgewicht addiert dein Körpergewicht und deine gesamte Ausrüstung. Die App zeigt nur Schirme, deren zugelassener Gewichtsbereich dich einschließt, und zeigt, wo du darin liegst (unten, Mitte oder oben) — ein Hinweis auf das Verhalten des Schirms.",
    pilotWeightLabel: "🧍 Dein Gewicht (kg)",
    gliderWeightLabel: "🪂 Schirmgewicht (kg)",
    harnessWeightLabel: "💺 Gurtzeug-Gewicht (kg)",
    reserveWeightLabel: "🆘 Rettungsgewicht (kg)",
    extraWeightLabel: "🎒 Zusatzausrüstung (kg)",
    ptvTotalLabel: "Gesamtgewicht",
    ptvClear: "Löschen",
    ptvApply: "Gewicht übernehmen",
    // Settings Modal
    settingsTitle: "Einstellungen",
    dataSourceTitle: "Datenquelle (Test-Modus)",
    dataSourceHelp: "HTTP/HTTPS oder S3 URL-Endpunkt für die JSON-Daten.",
    resetTestUrl: "Test S3-URL zurücksetzen",
    autoRefreshTitle: "Automatische Aktualisierung",
    autoRefreshHelp: "Wie oft die App den S3-Bucket abfragt.",
    disabled: "Deaktiviert",
    every60s: "Jede Minute",
    save: "Speichern",
    cancel: "Abbrechen",
    // Stats Bar
    totalLotsCount: "Lots",
    totalLots: "Gesamt Artikel",
    inSale: "Zum Verkauf",
    glidersCount: "Schirme 🪂",
    harnessesCount: "Gurtzeuge 💺",
    reservesCount: "Rettungen 🆘",
    accessoriesCount: "Zubehör 🛠",
    avgPrice: "Durchschn. Preis",
    priceRange: "Preisspanne",
    // Empty & Errors
    emptyTitle: "Keine Artikel entsprechen Ihren Kriterien",
    emptySub: "Versuchen Sie Ihre Suche zu ändern oder die Filter zurückzusetzen.",
    offlineModeBanner: "Demodaten — Produktionsdatei ist noch nicht verfügbar.",
    // Filter group labels, placeholders & fallbacks
    filterGroupType: "Typ",
    filterGroupLevel: "Stufe",
    ptvPlaceholder: "z. B. 85",
    priceMinPlaceholder: "Min €",
    priceMaxPlaceholder: "Max €",
    retry: "Erneut versuchen",
    errorTimeout: "Netzwerk-Timeout (5 s).",
    errorNetwork: "Netzwerkfehler.",
    // Alerts (new matching lots)
    alertOn: "Benachrichtigen",
    alertOff: "Alarm aktiv",
    alertTooltipOn: "Bei neuen Lots, die diesen Filtern entsprechen, benachrichtigen",
    alertTooltipOff: "Alarm für diese Filter aktiv — zum Deaktivieren klicken",
    alertNewMatchTitle: "{count} neue(s) Lot(s) für Ihren Alarm",
    alertViewBtn: "Ansehen",
    viewingNewLots: "{count} neue(s) Lot(s) aus Ihrem Alarm",
    showAllLots: "Alle anzeigen",
    alertAndMore: "+ {count} weitere",
    alertAllArticles: "alle Artikel",
    alertClose: "Schließen",
    alertSetupTitle: "Alarm aktivieren",
    alertSetupIntro: "Ein Popup erscheint in der App, sobald ein neues zum Verkauf stehendes Lot Ihrer Auswahl entspricht.",
    alertSetupWatching: "Überwachtes Kriterium:",
    alertSetupTabOpen: "Der Alarm funktioniert, solange dieser Tab geöffnet bleibt.",
    alertSetupBrowserNotif: "Auch benachrichtigen, wenn dieser Tab im Hintergrund ist (Systembenachrichtigung)",
    alertSetupConfirm: "Alarm aktivieren",
    compareMax: "Maximal 4 Lots zum Vergleich.",
    noBrand: "OHNE MARKE",
    noModel: "Modell nicht angegeben",
    articlesCount: "{count} Artikel",
    ptvLabel: "Startgewicht",
  },
};

export type TranslationKey = keyof typeof TRANSLATIONS.fr;

export function detectBrowserLanguage(): Language {
  if (typeof navigator === 'undefined') return 'fr';
  const langs = navigator.languages || [navigator.language];
  for (const l of langs) {
    const code = l.toLowerCase();
    if (code.startsWith('fr')) return 'fr';
    if (code.startsWith('de')) return 'de';
    if (code.startsWith('es')) return 'es';
    if (code.startsWith('en')) return 'en';
  }
  return 'fr';
}
